<template>
  <div class="app-date-time">
    <i class="far fa-calendar-alt" /> {{ dateTime }}
  </div>
</template>

<script>
import dayjs from 'dayjs';

const UPDATE_TIMEOUT = 60000;

let currentTimeout = null;

export default {
  name: 'AppDateTime',
  props: {
    dateTimeFormat: {
      type: String,
      default: 'DD/MM/YYYY - HH:mm'
    }
  },
  data() {
    return {
      dateTime: null
    };
  },
  mounted() {
    this.updateDateTimer();
  },
  methods: {
    setTimeout() {
      const toNextMinute = UPDATE_TIMEOUT - (new Date()).getSeconds() * 1000;
      currentTimeout = setTimeout(this.updateDateTimer, toNextMinute);
    },
    updateDateTimer() {
      this.dateTime = dayjs().format(this.dateTimeFormat);
      this.setTimeout();
    }
  },
  destroy() {
    clearTimeout(currentTimeout);
  }
};
</script>
